<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="超级偷袭配置" @back="goBack" /></span>
        </div>
        <el-table class="tableDesign" size="mini" :data="formData" border style="width: 50%">
          <el-table-column label="序号" align="center" width="100">
            <template slot-scope="{row,$index}">
              <span style="display:block;">{{ $index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="倍率" align="center">
            <template slot-scope="{row}">
              <el-input v-model="row.bet" placeholder="倍率" />
            </template>
          </el-table-column>
          <el-table-column label="权重" align="center">
            <template slot-scope="{row}">
              <el-input v-model="row.v" placeholder="权重" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{row,$index}">
              <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 2rem">
          <el-button type="primary" size="mini" @click="handleAdd()">新增</el-button>
          <el-button v-permisaction="['config:RewardPerfectStealEdit:save']" :disabled="isOnline === 1" type="primary" size="mini" @click="onSubmit()">保存</el-button>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  getActivtyStageRewardCfg,
  updateActivtyStageRewardCfg
} from '@/api/config/activity-cfg'

export default {
  name: 'RewardPerfectStealEdit',
  data() {
    return {
      isOnline: 0,
      aid: 0,
      type: '',
      defaultData:
       [
         { bet: 1, v: 3 }
       ],
      formData: {}
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      const postData = { type: this.type, aid: this.aid, reward: this.formData }
      updateActivtyStageRewardCfg({ data: JSON.stringify(postData) }).then(res => {
        this.msgSuccess(res.msg)
        this.getTables()
      })
    },
    getTables() {
      this.formData = []
      getActivtyStageRewardCfg({ id: this.aid }).then(res => {
        if (!res.data.reward) {
          this.formData = this.defaultData
        } else {
          this.formData = res.data.reward
        }
      })
    },
    handleDel(index) {
      this.formData.splice(index, 1)
    },
    handleAdd() {
      this.formData.push({ bet: 1, v: 3 })
    }
  }
}
</script>

<style scoped>
</style>
